import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { LinkService } from '../../_services/langhfre.service';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-white-paper',
  templateUrl: './white-paper.component.html',
  styleUrls: ['./white-paper.component.scss']
})
export class WhitePaperComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object

  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function(){});
      // $.getScript('../../../assets/js/owl.carousel.min.js', function(){});
      $.getScript('../../../../node_modules/slick-carousel/slick/slick.min.js', function () { });
      $.getScript('../../../assets/js/WhitePaper.js', function () { });
    }
    this.titleService.setTitle('[解説資料]アカデミックライティングを対象に Trinka、Grammaly、LanguageToolを比較');
    this.metaTagService.updateTag({ name: 'description', content: '3つの校正ツールを比較検証し、専門分野ごとの語法や出版適正の査定などを行えるTrinkaが学術ライティングに最適なツールであるということを具体的にご説明するPDFの解説資料です。' });
    this.metaTagService.updateTag({ property: 'og:title', content: '[解説資料]アカデミックライティングを対象に Trinka、Grammaly、LanguageToolを比較' });
    this.metaTagService.updateTag({ property: 'og:description', content: '3つの校正ツールを比較検証する解説資料をぜひご覧ください。自社調査の具体的なデータに基づき、Trinkaがアカデミックライティングに最適な校正ツールであるということをご説明しています。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/trinka-vs-grammarly-vs-language-tool' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "[解説資料]アカデミックライティングを対象に Trinka、Grammaly、LanguageToolを比較" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "3つの校正ツールを比較検証し、専門分野ごとの語法や出版適正の査定などを行えるTrinkaが学術ライティングに最適なツールであるということを具体的にご説明するPDFの解説資料です。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinka-vs-grammarly-vs-language-tool' });

    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  ngAfterViewInit() {

  }

  
}
